import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_donvitinh, Lists_loaitiente } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
    selector: 'app-dm-hopdongedit',
  templateUrl: './hopdongedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./hopdongedit.component.scss'],
    providers: [ListService, Repository]
})


export class hopdongeditComponent implements OnInit {

   
    quyen_them: boolean = false;
    quyen_sua: boolean = false;
    quyen_xoa: boolean = false;
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };

  inputkieumuahangs: any = [
    { Id: 1, Ma_Doi_Tuong: '1', Ten_Doi_Tuong: 'Mua hàng theo kế hoạch' }
    , { Id: 2, Ma_Doi_Tuong: '2', Ten_Doi_Tuong: 'Mua hàng ngoài kế hoạch' }
    
  ];
  inputkieuthanhtoans: any = [
    { Id: 0, Ma_Doi_Tuong: '0', Ten_Doi_Tuong: 'Trả góp' }
    , { Id: 1, Ma_Doi_Tuong: '1', Ten_Doi_Tuong: 'Trả thẳng' }

  ];
  public ngayky: Date = null;
  public hanthanhtoan: Date = null;
  inputparents: any;
  inputkhachhangs: any
  inputloaitientes: any
    indLoading: boolean = false;    
    doituongSelect: any = { Id: null, Ma_Doi_Tuong: null, Ten_Doi_Tuong: null,Ghi_Chu: null,Parent:null,Trang_Thai:null,Nhom_Doi_Tuong_ID:null,Don_Vi_Id:null,Ma_Ao:null,
      Doi_Tuong_Id: null, Kieu_Mua_Hang: null, Thanh_Toan: null, Huy_Hop_Dong: null, Gia_Ban: null
      , Gia_Tri: null, Tien_Te_Id: null, Gia_Tri_Ngoai_Te: null, Dat_Coc: null
      , Phu_Kien: null, Ngay_Ky: null, Ngay_KyS: null, Han_Thanh_Toan: null, Han_Thanh_ToanS: null
    };    
    nhomdtid:string=null;
  currentUser: any;
    @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
    @ViewChild('slKhachHangNCC', { static: false }) slKhachHangNCC: NgSelectComponent;
    @ViewChild('dateNgayKy', { static: false }) dateGhiTang: any;
    @ViewChild('dateHanThanhToan', { static: false }) dateKH: any;
    @Output() save: EventEmitter<any> = new EventEmitter();
  
   

    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
    @ViewChild("mafocus",{static:false}) mafocus : ElementRef;

    loadDataInit(nhomdoituongid:string, id:string, donviid: string){

      var authlogin = localStorage.getItem('currentUser');
      if (authlogin) {

        this.currentUser = JSON.parse(authlogin);
        var giatri = this.currentUser.ds_quyen.filter(name => name.id === nhomdoituongid.toLowerCase());
        if (giatri != null && giatri.length > 0) {
          if (giatri[0].them == true)
            this.quyen_them = true;
          else
            this.quyen_them = false;
          if (giatri[0].sua == true)
            this.quyen_sua = true;
          else
            this.quyen_sua = false;
          if (giatri[0].xoa == true)
            this.quyen_xoa = true;
          else
            this.quyen_xoa = false;
        }
      }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
        },500);
        //this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/null/'+donviid)
        //.subscribe(response => {            
        //    this.inputparents=response;
        //});
      this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv3', { NhomId: '532A61EA-D765-844B-8CBF-E610B209E332', MaGiaoDien: '', DonViId: this.currentUser.id_don_vi })
        .subscribe(response => {
          this.inputkhachhangs = response;
        });
     this.repo.getRequest("api/doituong/getall2/" + Lists_loaitiente.id + '/null/' + donviid)
        .subscribe(response => {
          this.inputloaitientes = response;
        });

      this.doituongSelect = {
                Id: null, Ma_Doi_Tuong: null, Ten_Doi_Tuong: null, Ghi_Chu: null, Parent: null, Trang_Thai: null, Nhom_Doi_Tuong_ID: nhomdoituongid, Don_Vi_Id: donviid, Ma_Ao: null,
                Doi_Tuong_Id: null, Kieu_Mua_Hang: null, Thanh_Toan: null, Huy_Hop_Dong: null, Gia_Ban: null
                , Gia_Tri: null, Tien_Te_Id: null, Gia_Tri_Ngoai_Te: null, Dat_Coc: null
                , Phu_Kien: null, Ngay_Ky: null, Ngay_KyS: null, Han_Thanh_Toan: null, Han_Thanh_ToanS: null
              };    
        
        if(id === null)
        {
            console.log("vao loaddatainit" + id);
            this.repo.getRequest("api/doituong/SinhMaDoiTuong/" + nhomdoituongid + '/'+donviid)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Ma_Doi_Tuong = response;
            });
          this.doituongSelect.Trang_Thai = true;
        }
        else {
            console.log(id);
          this.repo.getRequest("api/doituonghopdong/getbyid/" + id)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Id = id;
                this.doituongSelect.Ma_Doi_Tuong = response.Ma_Doi_Tuong;
                this.doituongSelect.Ten_Doi_Tuong = response.Ten_Doi_Tuong;
                this.doituongSelect.Trang_Thai = response.Trang_Thai;
                this.doituongSelect.Ghi_Chu = response.Ghi_Chu;
                this.doituongSelect.Parent = response.Parent;
                this.doituongSelect.Ma_Ao = response.Ma_Ao;


              this.doituongSelect.Doi_Tuong_Id = response.Doi_Tuong_Id;
              this.doituongSelect.Kieu_Mua_Hang = response.Kieu_Mua_Hang;
              this.doituongSelect.Thanh_Toan = response.Thanh_Toan;
              this.doituongSelect.Huy_Hop_Dong = response.Huy_Hop_Dong;
              this.doituongSelect.Gia_Ban = response.Gia_Ban;
              this.doituongSelect.Gia_Tri = response.Gia_Tri;
              this.doituongSelect.Tien_Te_Id = response.Tien_Te_Id;
              this.doituongSelect.Gia_Tri_Ngoai_Te = response.Gia_Tri_Ngoai_Te;
              this.doituongSelect.Dat_Coc = response.Dat_Coc;
              this.doituongSelect.Phu_Kien = response.Phu_Kien;
              this.doituongSelect.Ghi_Chu = response.Ghi_Chu;
              if (this.doituongSelect.Ngay_Ky != null)
                this.ngayky = new Date(this.doituongSelect.Ngay_Ky);
              if (this.doituongSelect.Han_Thanh_Toan != null)
                this.hanthanhtoan = new Date(this.doituongSelect.Han_Thanh_Toan);
              

               
            }); 
        }
        
       
    }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
            this.slCapTren.focus();
            event.preventDefault();
          }
   }
    public closeModal(){
        this.save.emit(null);
    }
    public saveproduct() {
        if (this.doituongSelect.Ten_Doi_Tuong == null || this.doituongSelect.Ten_Doi_Tuong == "") {
            swal('Lỗi!', 'Vui lòng nhập tên đối tượng!.', 'error');
            return;
      }

      if (this.ngayky != null)
        this.doituongSelect.Ngay_KyS = this.ngayky.getDate() + '/' + (this.ngayky.getMonth() + 1) + '/' + this.ngayky.getFullYear();
      if (this.hanthanhtoan != null)
        this.doituongSelect.Han_Thanh_ToanS = this.hanthanhtoan.getDate() + '/' + (this.hanthanhtoan.getMonth() + 1) + '/' + this.hanthanhtoan.getFullYear();

      this.repo.postRequest("api/doituonghopdong/addorupdate2",this.doituongSelect)
            .subscribe(response => {  
                console.log(response);
              if (response != null && response.match('-')) {
                this.doituongSelect.Id = response;
                this.save.emit(this.doituongSelect);
              }
              else {
                swal('Lỗi!', response, 'error');
              }
            }); 
    }
   
    
   

   


}
